<template>
  <div class="neo-section">
    <div class="neo-container">
      <div class="neo-about" data-aos="fade-up">
        <el-row type="flex" :gutter="100">
          <el-col :md="8">
            <div class="neo-about__title">
              <h2>Easily Send Money Home with NEO</h2>
            </div>
          </el-col>
          <el-col :md="16">
            <div class="neo-about__description">
              <p>
                Send money quickly to your family in Nigeria and pay back with
                no interest. With NEO, you can easily check your money anytime
                and make simple monthly repayments!
              </p>

              <ul>
                <li v-for="(feature, i) in features" :key="i">
                  <span></span>
                  <h5>{{ feature.heading }}</h5>
                  <p>{{ feature.description }}</p>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NeoAbout",
  data() {
    return {
      features: [
        {
          heading: "Complete Control",
          description:
            "Easy access to your money anytime, with extra secure login.",
        },
        {
          heading: "Worldwide Trust",
          description:
            "Meets international rules with safe ID checks using your fingerprints or face scan.",
        },
        {
          heading: "Use Anywhere",
          description:
            "Transfer funds to any bank in Nigeria with ease. Plus, unlock the NEO Card – accepted anywhere in Nigeria.",
        },
        {
          heading: "Bank on Your Phone",
          description:
            "Easily monitor spending and manage your cash with our app",
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.neo-about {
  display: flex;
  justify-content: space-between;

  &__description {
    ul {
      width: 100%;
      padding: 0;
      margin-top: 80px;
      list-style: none;
      display: grid;
      grid-template-columns: 1fr 1fr;

      li {
        padding-left: 50px;
        margin-bottom: 60px;
        position: relative;

        span {
          position: absolute;
          top: 3px;
          left: 0;
          height: 25px;
          width: 25px;
          border-radius: 100px;
          background: #121212;
          box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
        }

        h5 {
          margin-bottom: 15px;
        }

        p {
          font-size: 1.125rem;
          width: 85%;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .neo-about {
    flex-direction: column;

    &__title {
      margin-bottom: 15px;
    }
  }
}

@media (max-width: 768px) {
  .neo-about__description ul {
    grid-template-columns: 1fr;

    li {
      margin-right: 0;

      p {
        width: 100%;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
